<div class="advance-search-modal flex flex--col">
	<div class="modal__content flex__item u-pv0 u-pr+">
		<wfm-tabs class="flex flex__item flex--col">
			<!--Criteria Tab-->
			<wfm-tabs-item class="flex flex__item flex--col" [label]="'advancedSearch.criteriaText' | translate">
				<ng-container *ngIf="!isLoading">
					<div #advanceSearchContainer class="flex flex__item flex--col">
						<!--Filter tag panel -->
						<div (resized)="resized($event, filterTagPanel.offsetHeight)" #filterTagPanel
						     style="max-height: 12rem" wfmScrollbar>
							<wfm-filter-tag-panel (scrollTo)="scrollTo($event)"
							                      [isScrollToEnabled]="true"
							                      [filterTags]="filterTags"
							                      [showAllTags]="false"
							                      (removeTag)="filterTagPanelChange($event)"
							                      [displayOnlyLabels]="true"></wfm-filter-tag-panel>
						</div>
						<!-- Remote repository warning -->
						<div *ngIf="isRemoteRepositoriesSelected" #remoteRepoWarning>
							<label class="form__label label__container u-mt--- form__label--bottom">
								<svg-icon
									name="ico-info-32"
									id="repo-info-icon"
									class="u-pr---"
									[svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
								</svg-icon>
								<span id="repo-warning-msg"> {{'advanced.search.remoteArchiveWarning' | translate}} </span>
							</label>
						</div>
						<!-- Create/Edit WL and adavance search inputs -->
						<div #advanceSearchInputs style="flex: 1 1 auto; overflow-y: auto; max-height: 50rem"
						     class="u-mt- u-pr+"
						     wfmScrollbar>
							<!--Worklist name-->
							<div id="worklistName" *ngIf="!isAdvanceSearch" #inputElement
							     class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label for="worklist-name" class="form__label label__container u-mt--- form__label--bottom">
											<span> {{'advanceSearch.worklistNameLabel' | translate}} <span
												aria-label="required">*</span></span>
									</label>
								</div>
								<div class="flex__item">
									<div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
										<input [(ngModel)]="searchParams.worklistName"
										       (ngModelChange)="textValueChange('worklistName')"
										       [placeholder]="'advanceSearch.worklistNamePlaceHolderText' | translate"
										       id="worklist-name" type="text" class="textbox u-mb----"
										       [attr.aria-invalid]="!!searchParamsError.worklistName" maxlength="50">
										<ng-container
											*ngTemplateOutlet="clearInput; context: { key: 'worklistName', value: searchParams.worklistName }"></ng-container>
									</div>
									<div class="error-content">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.worklistName }"></ng-container>
									</div>
								</div>
							</div>
							<!-- Patient Name-->
							<div id="patientName" #inputElement class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label for="search-input-patientName"
									       class="form__label label__container u-mt--- form__label--bottom">
										<span> {{'advanceSearch.patientNameLabel' | translate}} </span>
										<svg-icon
											[tooltip]="'advancedSearch.validation.patientSearch' | translate"
											tooltipWidth="182px"
											name="ico-info-32"
											id="icon-patientName"
											[svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
										</svg-icon>
									</label>
								</div>
								<div class="flex__item">
									<div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
										<input [(ngModel)]="searchParams.patientName"
										       (ngModelChange)="textValueChange('patientName')"
										       [placeholder]="'advanceSearch.patientNamePlaceHolderText' | translate"
										       id="search-input-patientName" type="text" class="textbox u-mb----"
										       [attr.aria-invalid]="!!searchParamsError.patientName" maxlength="41" dir="auto">
										<ng-container
											*ngTemplateOutlet="clearInput; context: { key: 'patientName', value: searchParams.patientName  }"></ng-container>
									</div>
									<div class="error-content">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.patientName }"></ng-container>
									</div>
								</div>
							</div>
							<!--MRN-->
							<div id="mrn" #inputElement
							     class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label id="mrn-lbl" class="form__label label__container u-mt--- form__label--bottom">
										<span> {{'advanceSearch.mrnLabel' | translate}} </span>
										<svg-icon
											[tooltip]="mrnInfoTip"
											tooltipWidth="182px"
											name="ico-info-32"
											id="icon-mrn"
											[svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
										</svg-icon>
									</label>
								</div>
								<div class="flex__item">
									<div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
										<input [(ngModel)]="searchParams.mrn"
										       (ngModelChange)="textValueChange('mrn'); clearInputField('nhi')"
										       [placeholder]="'advanceSearch.mrnPlaceHolderText' | translate"
										       type="text" class="textbox u-mb----"
										       id="search-input-mrn"
										       [attr.aria-invalid]="!!searchParamsError.mrn" maxlength="64">
										<ng-container
											*ngTemplateOutlet="clearInput; context: { key: 'mrn', value: searchParams.mrn }"></ng-container>
									</div>
									<div class="error-content">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.mrn }"></ng-container>
									</div>
								</div>
							</div>
							<!--NHI#-->
							<div id="nhi" *ngIf="isNhiEnabled" #inputElement
							     class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label id="nhi-lbl" class="form__label label__container u-mt--- form__label--bottom">
										<span> {{'advanceSearch.nhiLabel' | translateNhi | translate }} </span>
										<svg-icon *ngIf= "!isNHIPatternEmpty"
											[tooltip]="nhiInfoTip"
											tooltipWidth="182px"
											name="ico-info-32"
											id="icon-nhi"
											[svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
										</svg-icon>
									</label>
								</div>
								<div class="flex__item">
									<div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
										<input [(ngModel)]="searchParams.nhi"
										       (ngModelChange)="textValueChange('nhi'); clearInputField('mrn')"
										       [placeholder]="'advanceSearch.nhiPlaceHolderText' | translateNhi | translate"
										       type="text" class="textbox u-mb----"
										       id="search-input-nhi"
										       [attr.aria-invalid]="!!searchParamsError.nhi">
										<ng-container
											*ngTemplateOutlet="clearInput; context: { key: 'nhi', value: searchParams.nhi }"></ng-container>
									</div>
									<div class="error-content">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.nhi }"></ng-container>
									</div>
								</div>
							</div>
							<!--DOB-->
							<div id="dob" #inputElement class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label class="form__label label__container u-mt--- form__label--bottom">
										<span> {{'advanceSearch.dobLabel' | translate}} </span>
                    <svg-icon
											[tooltip]="dobInfoTip"
											tooltipWidth="182px"
											name="ico-info-32"
											id="icon-dob"
											[svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
										</svg-icon>
									</label>
								</div>
								<div class="flex__item" id="patientBirthDate-date-picker">
									<wfm-date-picker-range #dobDatePickerComponent
										[placeholder]="'advancedSearch.dateOfBirthPlaceholder' | translate"
										[format]="dateTimePref.inputFormat"
										[placeholder]="dateTimePref.placeholderFormat"
										[formatDelimiter]="dateTimePref.delimiter"
										[asButton]="false"
										[customRangeOnly]="true"
										[(startValue)]="searchParams.dob.startTime"
										[(endValue)]="searchParams.dob.endTime"
										(endValueChange)="dobValueChange()"
										(startValueChange)="dobValueChange()"
										(errorChange)="setDateError($event, 'dob')"
										[disableUserInput]="false"
									></wfm-date-picker-range>
									<div class="error-content u-mt----">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.dob }"></ng-container>
									</div>
								</div>
							</div>
							<!--Procedure-->
							<div id="descriptions" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label class="form__label label__container u-mt--- form__label--bottom">
										<span> {{'customWorklist.examDescriptionMsg' | translate}} </span>
									</label>
								</div>
								<div class="flex__item">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.examDescriptionPlaceHolderText' | translate"
                    [id]="'descriptions'"
                    searchLabel="advanceSearch.examDescriptionFilterLabel"
                    labelField="name"
                    [multiple]="true"
                    [enableInternalSearch]="false"
                    (queryStr)="procedureDescStrSearch($event)"
                    [items]="preloadFilters.descriptions"
                    [(value)]="searchParams.descriptions"
                    (valueChange)="dropDownValueChange('descriptions')">
                  </wfm-virtual-list-dropdown>
									<div role="alert" class="form__error-text"></div>
								</div>
							</div>
							<!--Accession#-->
							<div id="accession" #inputElement class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label id="accession-lbl" class="form__label label__container u-mt--- form__label--bottom">
										<span> {{'advanceSearch.accessionNumberLabel' | translate}}</span>
										<svg-icon
											[tooltip]="accessionInfoTip"
											tooltipWidth="182px"
											name="ico-info-32"
											id="icon-accession"
											[svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
										</svg-icon>
									</label>
								</div>
								<div class="flex__item">
									<div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
										<input [placeholder]="'advanceSearch.accessionNumberPlaceHolderText' | translate"
										       [(ngModel)]="searchParams.accession"
										       (ngModelChange)="textValueChange('accession')"
										       type="text" class="textbox u-mb----"
										       id="search-input-accession"
										       [attr.aria-invalid]="!!searchParamsError.accession" maxlength="32">
										<ng-container
											*ngTemplateOutlet="clearInput; context: { key: 'accession', value: searchParams.accession }"></ng-container>
									</div>
									<div class="error-content">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.accession }"></ng-container>
									</div>
								</div>
							</div>
							<!--Study time/date-->
							<div id="timeOfExam" #inputElement class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label class="form__label label__container u-mt--- form__label--bottom">
										{{'advanceSearch.timeOfExamLabel' | translate}}
									</label>
								</div>
								<div class="flex__item">
									<wfm-date-picker-range
										[ngClass]="{'error__field': !!searchParamsError.timeOfExam}"
										[required]="true"
										[id]="'timeOfExam'"
										[format]="dateTimePref.inputFormat"
										[placeholder]="dateTimePref.placeholderFormat"
										[formatDelimiter]="dateTimePref.delimiter"
										[asButton]="false"
										[customRangeOnly]="false"
										[startValue]="searchParams.timeOfExam.startTime"
										[endValue]="searchParams.timeOfExam.endTime"
										[option]="searchParams.timeOfExam.option"
										(optionChange)="timeOfExamValueChange($event, 'option')"
										(endValueChange)="timeOfExamValueChange($event, 'endTime')"
										(startValueChange)="timeOfExamValueChange($event, 'startTime')"
										(errorChange)="setDateError($event, 'timeOfExam')"
										[disableUserInput]="true"
										(outSideDatePickerRange)="outSideClickDatePicker('timeOfExam')"
									></wfm-date-picker-range>
									<div class="error-content u-mt----">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.timeOfExam }"></ng-container>
									</div>
								</div>
							</div>
							<!--Verified time/date-->
							<div id="verifiedDateTime" #inputElement class="flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label class="form__label label__container u-mt--- form__label--bottom">
										{{'label.verifiedTimeDate' | translate}}
									</label>
								</div>
								<div class="flex__item">
									<wfm-date-picker-range
										[required]="true"
										[format]="dateTimePref.inputFormat"
										[placeholder]="dateTimePref.placeholderFormat"
										[formatDelimiter]="dateTimePref.delimiter"
										[asButton]="false"
										[customRangeOnly]="false"
										[(startValue)]="searchParams.verifiedDateTime.startTime"
										[(endValue)]="searchParams.verifiedDateTime.endTime"
										[(option)]="searchParams.verifiedDateTime.option"
										(errorChange)="setDateError($event, 'verifiedDateTime')"
										[disableUserInput]="true"
										(outSideDatePickerRange)="outSideClickDatePicker('verifiedDateTime')"
									></wfm-date-picker-range>
									<div class="error-content u-mt----">
										<ng-container
											*ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.verifiedDateTime }"></ng-container>
									</div>
								</div>
							</div>
							<!--Modality-->
							<div id="modality" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
								<div style="width: 30%">
									<label class="form__label label__container u-mt--- form__label--bottom">
										<span> {{'advanceSearch.modalityLabel' | translate}} </span>
									</label>
								</div>
								<div class="flex__item" id="search-container-modality-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.modalityPlaceHolderText' | translate"
                    [id]="'modality'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.modality"
                    [(value)]="searchParams.modality"
                    (valueChange)="dropDownValueChange('modality')">
                  </wfm-virtual-list-dropdown>
									<div role="alert" class="form__error-text"></div>
								</div>
							</div>
              <!--Body part-->
              <div id="bodyParts" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.bodyPartLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-bodyParts-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.bodyPartPlaceHolderText' | translate"
                    [id]="'bodyParts'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.bodyParts"
                    [(value)]="searchParams.bodyParts"
                    (valueChange)="dropDownValueChange('bodyParts')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Department-->
              <div id="departmentIds" #inputElement
                   class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.departmentLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-departments-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.departmentPlaceHolderText' | translate"
                    [id]="'departments'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.departmentIds"
                    [(value)]="searchParams.departmentIds"
                    (valueChange)="dropDownValueChange('departmentIds')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Department C-key-->
              <div id="departmentId" #inputElement class="flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label for="search-input-departments"
                         class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.DepartmentCKeyLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item">
                  <div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
                    <input [placeholder]="'advanceSearch.DepartmentCKeyPlaceHolderText' | translate"
                           [(ngModel)]="searchParams.departmentId"
                           (ngModelChange)="textValueChange('departmentId')"
                           id="search-input-departments" type="text" class="textbox u-mb----"
                           [attr.aria-invalid]="!!searchParamsError.departmentId" maxlength="32">
                    <ng-container
                      *ngTemplateOutlet="clearInput; context: { key: 'departmentId', value: searchParams.departmentId  }"></ng-container>
                  </div>
                  <div class="error-content">
                    <ng-container
                      *ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.departmentId }"></ng-container>
                  </div>
                </div>
              </div>
              <!--Designated author-->
              <div id="designatedAuthor" #inputElement
                   class="flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'workloadManager.listContainer.label.designatedAuthor' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-designatedAuthor-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.designatedAuthorPlaceHolderText' | translate"
                    [id]="'designatedAuthor'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.designatedAuthor"
                    [(value)]="searchParams.designatedAuthor"
                    (valueChange)="dropDownValueChange('designatedAuthor')">
                  </wfm-virtual-list-dropdown>
                  <div class="error-content u-mt----">
                    <ng-container
                      *ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.designatedAuthor }"></ng-container>
                  </div>
                </div>
              </div>
              <!--Exceptions-->
              <div id="exceptions" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify" *ngIf="isTruePacs">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanced.search.exception' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-examFlags-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.exceptionPlaceHolderText' | translate"
                    [id]="'examFlags'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.exceptions"
                    [(value)]="searchParams.exceptions"
                    (valueChange)="dropDownValueChange('exceptions')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Exam specialty-->
              <div id="specialties" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.examSpecialtyLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-specialties-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.examSpecialtyPlaceHolderText' | translate"
                    [id]="'specialties'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.specialties"
                    [(value)]="searchParams.specialties"
                    (valueChange)="dropDownValueChange('specialties')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Exam status-->
              <div id="examStatusIds" #inputElement
                   class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.examStatusLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-examStatus-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.examStatusPlaceHolderText' | translate"
                    [id]="'examStatus'"
                    labelField="examStatusDescription"
                    [multiple]="true"
                    [items]="preloadFilters.examStatusIds"
                    [(value)]="searchParams.examStatusIds"
                    (valueChange)="dropDownValueChange('examStatusIds')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Findings-->
              <div id="findings" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.findingsLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-aiFinding-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.findingsPlaceHolderText' | translate"
                    [id]="'aiFinding'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.aiFinding"
                    [(value)]="searchParams.aiFinding"
                    (valueChange)="dropDownValueChange('aiFinding')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Initial author-->
              <div id="initialInterpreters" #inputElement
                   class="flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.initialAuthorLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-initialAuthor-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [id]="'initialAuthor'"
                    [placeholder]="'advanceSearch.initialAuthorPlaceHolderText' | translate"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.initialInterpreters"
                    [(value)]="searchParams.initialInterpreters"
                    (valueChange)="dropDownValueChange('initialInterpreters')">
                  </wfm-virtual-list-dropdown>
                  <div class="error-content u-mt----">
                    <ng-container
                      *ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.initialInterpreters }"></ng-container>
                  </div>
                </div>
              </div>
              <!--Institute-->
              <div id="instituteList" #inputElement
                   class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.instituteLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-institute-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.institutePlaceHolderText' | translate"
                    [id]="'institute'"
                    labelField="instituteName"
                    [multiple]="true"
                    [items]="preloadFilters.instituteList"
                    [disableByField]="'disabled'"
                    [(value)]="searchParams.instituteList"
                    (valueChange)="dropDownValueChange('instituteList')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Modality station name-->
              <div id="equipment" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.ModalityStationNameLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-equiment">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.ModalityStationNameLabelPlaceHolderText' | translate"
                    [id]="'equipment'"
                    labelField="name"
                    [multiple]="true"
                    [(value)]="searchParams.equipment"
                    [items]="preloadFilters.equipment"
                    (valueChange)="dropDownValueChange('equipment')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Order#-->
              <div id="orderNumber" #inputElement class="flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.orderNumberLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item">
                  <div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
                    <input [placeholder]="'advanceSearch.orderNumberPlaceHolderText' | translate"
                           [(ngModel)]="searchParams.orderNumber"
                           (ngModelChange)="textValueChange('orderNumber')"
                           id="search-input-orderNumber" type="text" class="textbox u-mb----"
                           [attr.aria-invalid]="!!searchParamsError.orderNumber" maxlength="64">
                    <ng-container
                      *ngTemplateOutlet="clearInput; context: { key: 'orderNumber', value: searchParams.orderNumber }"></ng-container>
                  </div>
                  <div class="error-content">
                    <ng-container
                      *ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.orderNumber }"></ng-container>
                  </div>
                </div>
              </div>
              <!--Order location-->
              <div id="orderingLocation" #inputElement
                   class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.orderingLocationLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-orderingLocation-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.orderingLocationPlaceHolderText' | translate"
                    [id]="'orderingLocation'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.orderingLocation"
                    [(value)]="searchParams.orderingLocation"
                    (valueChange)="dropDownValueChange('orderingLocation')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Ordering location c-key-->
              <div id="orderingLocationId" #inputElement
                   class="flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label for="search-orderingLocationId"
                         class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.OrderingLocationCKeyLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-input-orderingLocationId">
                  <div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
                    <input [placeholder]="'advanceSearch.OrderingLocationCKeyPlaceHolderText' | translate"
                           [(ngModel)]="searchParams.orderingLocationId"
                           (ngModelChange)="textValueChange('orderingLocationId')"
                           id="search-orderingLocationId" type="text" class="textbox u-mb----"
                           [attr.aria-invalid]="!!searchParamsError.orderingLocationId" maxlength="32">
                    <ng-container
                      *ngTemplateOutlet="clearInput; context: { key: 'orderingLocationId', value: searchParams.orderingLocationId }"></ng-container>
                  </div>
                  <div class="error-content">
                    <ng-container
                      *ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.orderingLocationId }"></ng-container>
                  </div>
                </div>
              </div>
              <!--Patient location-->
              <div id="currentLocation" #inputElement
                   class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.patientLocationLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-patientLocation-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.patientLocationPlaceHolderText' | translate"
                    [id]="'patientLocation'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.currentLocation"
                    [(value)]="searchParams.currentLocation"
                    (valueChange)="dropDownValueChange('currentLocation')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Priority-->
              <div id="priority" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'workloadManager.listContainer.label.priority' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-priority-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.priorityPlaceHolderText' | translate"
                    [id]="'priority'"
                    labelField="priorityName"
                    [multiple]="true"
                    [items]="preloadFilters.priority"
                    [(value)]="searchParams.priority"
                    (valueChange)="dropDownValueChange('priority')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Report status-->
              <div id="reportStatusIds" #inputElement
                   class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.reportStatusLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-ReportStatus-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.reportStatusPlaceHolderText' | translate"
                    [id]="'ReportStatus'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.reportStatusIds"
                    [(value)]="searchParams.reportStatusIds"
                    (valueChange)="dropDownValueChange('reportStatusIds')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
              <!--Referring Physician-->
              <div id="referringPhysician" #inputElement
                   class="flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.referringPhysicianLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-referringPhysician-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.referringPhysicianPlaceHolderText' | translate"
                    [id]="'referringPhysician'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.referringPhysician"
                    [(value)]="searchParams.referringPhysician"
                    (valueChange)="dropDownValueChange('referringPhysician')">
                  </wfm-virtual-list-dropdown>
                  <div class="error-content u-mt----">
                    <ng-container
                      *ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.referringPhysician }"></ng-container>
                  </div>
                </div>
              </div>
              <!--Responsible author-->
              <div id="radiologists" #inputElement
                   class="flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.responsibleAuthorLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-responsibleAuthor-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.responsibleAuthorPlaceHolderText' | translate"
                    [id]="'responsibleAuthor'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.radiologists"
                    [(value)]="searchParams.radiologists"
                    (valueChange)="dropDownValueChange('radiologists')">
                  </wfm-virtual-list-dropdown>
                  <div class="error-content u-mt----">
                    <ng-container
                      *ngTemplateOutlet="errorMsg; context: { msg: searchParamsError.radiologists }"></ng-container>
                  </div>
                </div>
              </div>
              <!--Site-->
              <div id="site" #inputElement class="u-pb- flex flex--row flex--nowrap flex--top flex--justify">
                <div style="width: 30%">
                  <label class="form__label label__container u-mt--- form__label--bottom">
                    <span> {{'advanceSearch.SiteLabel' | translate}} </span>
                  </label>
                </div>
                <div class="flex__item" id="search-container-site-dropdown-selected-tags">
                  <wfm-virtual-list-dropdown
                    [placeholder]="'advanceSearch.SitePlaceHolderText' | translate"
                    [id]="'site'"
                    labelField="name"
                    [multiple]="true"
                    [items]="preloadFilters.site"
                    [(value)]="searchParams.site"
                    (valueChange)="dropDownValueChange('site')">
                  </wfm-virtual-list-dropdown>
                  <div role="alert" class="form__error-text"></div>
                </div>
              </div>
						</div>
					</div>
				</ng-container>
				<!--Loading/Spinner container-->
				<div *ngIf="isLoading" style="height:50rem;"
				     class="flex flex--row flex--nowrap flex--center flex--middle spinner">
					<wfm-spinner size="40"></wfm-spinner>
				</div>
			</wfm-tabs-item>

			<!--Preferences Tab-->
			<wfm-tabs-item [label]="'advancedSearch.preferencesText' | translate">
        <div #preferenceTabContainer>
          <!--zero exam images-->
          <div class="u-pb flex flex--row flex--nowrap flex--top flex--justify" id="zero-image-exams">
            <div style="width: 30%">
              <label class="form__label label__container u-mt--- form__label--bottom">
                {{'advanceSearch.zeroImageExams' | translate}}
              </label>
            </div>
            <div class="flex__item">
              <div id="button-group" class="button-group">
                <input id="exclude" type="radio" name="zeroImageExam"
                       [(ngModel)]="searchParams.excludeZeroImageExams" [value]="true">
                <label for="exclude" class="button button--icon-block">
                  <span>{{'advanceSearch.exclude' | translate}}</span>
                </label>
                <input id="include" type="radio" name="zeroImageExam"
                       [(ngModel)]="searchParams.excludeZeroImageExams" [value]="false">
                <label for="include" class="button button--icon-block">
                  <span>{{'advanceSearch.include' | translate}}</span>
                </label>
              </div>
            </div>
          </div>
          <!--worklist order by-->
          <div [ngClass]="{'u-pb' : isAdvanceSearch}" class="flex flex--row flex--nowrap flex--top flex--justify"
               id="order-by-radio">
            <div style="width: 30%">
              <label class="form__label label__container u-mt--- form__label--bottom"
                     id="exams-order-by">
                {{'advanceSearch.orderBy' | translate}}
              </label>
            </div>
            <div id="worklist-order-by" class="flex__item">
              <div class="u-pb--- u-mt---">
                <label for="order-by-verified-time" class="radio u-mr">
                  <input [(ngModel)]="searchParams.orderBy" [value]="false"
                         name="orderBy" id="order-by-verified-time" type="radio" class="radio__input">
                  <span class="radio__label">{{ 'advanceVerifiedDateTime' | translate}}</span>
                </label>
                <label for="order-by-study-time" class="radio">
                  <input [(ngModel)]="searchParams.orderBy" [value]="true"
                         name="orderBy" id="order-by-study-time" type="radio" class="radio__input">
                  <span class="radio__label">{{ 'advanceStudyDateTime' | translate}}</span>
                </label>
              </div>
              <div>
                <label for="priority-input-statsOnTop" class="checkbox">
                  <input [(ngModel)]="searchParams.statsOnTop"
                         name="statsOnTop" id="priority-input-statsOnTop" type="checkbox" class="checkbox__input">
                  <span class="checkbox__label">{{'advanced.search.priority' | translate}}</span>
                </label>
              </div>
            </div>
          </div>
          <!--viewer preference-->
          <div *ngIf="!isAdvanceSearch" class="u-pb flex flex--row flex--nowrap flex--top flex--justify">
					<div style="width: 30%">
						<label id="viewer-preference-lbl" class="form__label label__container u-mt--- form__label--bottom">
							{{'viewer.preferences' | translate}}
						</label>
					</div>
					<div id="viewer-preference" class="flex__item">
						<label for="preference-container-viewerPreferences" class="checkbox u-mt---">
							<input [(ngModel)]="searchParams.viewerPreference"
							       name="viewerPreference" id="preference-container-viewerPreferences" type="checkbox"
							       class="checkbox__input">
							<span class="checkbox__label">{{'advanceSearch.preferenceViewerLaunchLabel' | translate}}</span>
						</label>
					</div>
				</div>
        </div>
			</wfm-tabs-item>
		</wfm-tabs>
	</div>
	<!--Footer actions-->
	<div class="modal__footer">
		<button type="button" class="button button--primary button--accept text-ellipsis display-inline-block"
		        id="decision-notification-yes-btn" tabindex="1"
		        [innerHTML]="acceptBtnLabel"
		        [disabled]="isActionButtonDisabled"
		        (click)="action()"></button>
		<button *ngIf="(isAdvanceSearch && canSaveAsWorkList) || !isAdvanceSearch" type="button"
		        class="button button--tertiary button--reject text-ellipsis display-inline-block"
		        id="decision-notification-no-btn" tabindex="2"
		        [innerHTML]="rejectBtnLabel"
		        [disabled]="isRejectButtonDisabled"
		        (click)="cancelOrSave()"></button>
	</div>
</div>

<ng-template #mrnInfoTip>
	{{ 'advancedSearch.validation.exactMatch' | translate }}
	<br/>
	{{ 'advancedSearch.validation.wildcard' | translate }}
	<br/>
	{{ 'advancedSearch.validation.example' | translate }}
	<br/>
	{{ 'advancedSearch.validation.prefixExample' | translate }}
	<br/>
	{{ 'advancedSearch.validation.suffixExample' | translate }}
</ng-template>

<ng-template #dobInfoTip>
  {{ 'advancedSearch.validation.date.year' | translate }}
  <br/>
  {{ 'advancedSearch.validation.date' | translate }}
</ng-template>

<ng-template #nhiInfoTip>
	<span [innerHTML]="'advancedSearch.validation.nhi' | translateNhi | translate"></span>
</ng-template>

<ng-template #accessionInfoTip>
	{{ 'advancedSearch.validation.exactMatch' | translate }}
	<br/>
	{{ 'advancedSearch.validation.wildcard.prefixSearch' | translate }}
	<br/>
	{{ 'advancedSearch.validation.example' | translate }}
	<br/>
	{{ 'advancedSearch.validation.prefixExample' | translate }}
</ng-template>

<ng-template #errorMsg let-errorMessage="msg">
	<div id="search-input-{{errorMessage}}-error-message" *ngIf="errorMessage" role="alert" class="form__error-text">
		<svg-icon
			name="ico-form-error-16"
			svgClass="close-icon"
			class="u-mr---"
			[svgStyle]="{ 'width.px': '14', 'height.px': '14' }"
		>
		</svg-icon>
		{{errorMessage | translateNhi | translate}}
	</div>
</ng-template>

<ng-template #clearInput let-key="key" let-value="value">
	<div class="filter__icon" *ngIf="value">
		<svg-icon name="ico-close-16"
		          (click)="clearInputField(key)"
		          [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }"
		></svg-icon>
	</div>
</ng-template>
